import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { ParamDescription } from "by/gamefactory/cityversetycoon/composition/module/ParamDescription";
import { EditPriceResourcePackage } from "./resources/EditPriceResourcePackage";
import { EditPriceModuleFlowExecutor } from "./EditPriceModuleFlowExecutor";
import { EditPricePopupScene } from "./scene/EditPricePopupScene";
import { EditPriceModel } from "./models/EditPriceModel";
import { EditPriceController } from "./controllers/EditPriceController";
import { ShowEditPriceSceneParams } from "./scene/ShowEditPriceSceneParams";
import { CongratulationsPopupScene } from "../congratulations/CongratulationsPopupScene";
import { CancellationToken } from "../../../../shared/async/CancellationToken";
import { EditPriceWarningResourcePackage } from "./warningmessage/resources/EditPriceWarningResourcePackage";
import { WarningMessagePopupScene } from "./warningmessage/WarningMessagePopupScene";

export class EditPriceModule extends BaseModule<boolean> {
    private editPriceResources: EditPriceResourcePackage;
    private editPriceWarningResources: EditPriceWarningResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(EditPriceModuleFlowExecutor, EditPriceModuleFlowExecutor);

        this.internalContainer.register("IEditPriceModel", EditPriceModel);
        this.internalContainer.register("IEditPriceController", EditPriceController);
        this.internalContainer.register(EditPricePopupScene, EditPricePopupScene);
        this.internalContainer.register("EditPricePopupSceneFactory", {
            useValue: async (showParams: ShowEditPriceSceneParams) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    EditPricePopupScene,
                    new ParamDescription(ShowEditPriceSceneParams, showParams)
                );
            }
        });

        this.internalContainer.register(CongratulationsPopupScene, CongratulationsPopupScene);
        this.internalContainer.register("CongratulationsPopupSceneFactory", {
            useValue: async (isAddToMarketplace: boolean, cancellationToken: CancellationToken) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    CongratulationsPopupScene,
                    new ParamDescription(Boolean, isAddToMarketplace),
                    new ParamDescription(CancellationToken, cancellationToken)
                );
            }
        });

        this.internalContainer.register(WarningMessagePopupScene, WarningMessagePopupScene);
        this.internalContainer.register("WarningMessagePopupSceneFactory", {
            useValue: async () => {
                return await this.resolve(WarningMessagePopupScene);
            }
        });

        this.editPriceResources = new EditPriceResourcePackage();
        await this.editPriceResources.load();
        this.internalContainer.registerInstance(EditPriceResourcePackage, this.editPriceResources);

        this.editPriceWarningResources = new EditPriceWarningResourcePackage();
        await this.editPriceWarningResources.load();
        this.internalContainer.registerInstance(EditPriceWarningResourcePackage, this.editPriceWarningResources);

        await super.build();
    }

    public async start(showParams?: ShowEditPriceSceneParams): Promise<boolean> {
        const executor = await this.internalContainer.resolve(EditPriceModuleFlowExecutor);
        const result = await executor.execute(this, showParams);
        this.dispose();
        return result;
    }

    public override dispose(): void {
        this.editPriceResources.destroy();
        this.editPriceWarningResources.destroy();
        super.dispose();
    }
}
